import * as React from "react";

interface ReasonFieldProps {
  id?: string;
  label?: string;
  value: string;
  onChange: (value: string) => void;
  minLength?: number;
  required?: boolean;
  placeholder?: string;
  hint?: string;
}

export function ReasonField({
  id = "reason-field",
  label = "Причина",
  value,
  onChange,
  minLength = 1,
  required = false,
  placeholder = "Укажите причину...",
  hint,
}: ReasonFieldProps): React.JSX.Element {
  const showError = value.length > 0 && value.length < minLength;
  const errorId = `${id}-error`;
  const hintId = `${id}-hint`;

  const describedBy =
    showError ? errorId : hint ? hintId : undefined;

  return (
    <div className="flex flex-col gap-1.5">
      <label
        htmlFor={id}
        className="text-[12px] font-[500] text-[var(--fg)]"
      >
        {label}
        {required && <span className="text-[var(--danger)] ml-0.5" aria-hidden="true">*</span>}
      </label>
      <textarea
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        required={required}
        rows={3}
        aria-invalid={showError}
        aria-describedby={describedBy}
        className="w-full font-[var(--font)] text-[13px] px-3 py-2 rounded-[var(--radius-sm)] border border-[var(--border)] bg-[var(--surface)] text-[var(--fg)] resize-vertical min-h-[72px] transition-colors focus:outline-none focus:border-[var(--accent)] focus:ring-1 focus:ring-[var(--accent-weak)]"
      />
      {showError && (
        <span
          id={errorId}
          role="status"
          aria-live="polite"
          className="text-[11px] text-[var(--danger)]"
        >
          Минимум {minLength} символов (сейчас {value.length})
        </span>
      )}
      {hint && !showError && (
        <span id={hintId} className="text-[11px] text-[var(--muted)]">{hint}</span>
      )}
    </div>
  );
}
